var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta-content",class:[
    `cta-content--${_vm.block.text_position}`,
    _vm.hasCountdownDate ? 'cta-content--with-countdown' : '',
    _vm.block.is_full ? 'full' : '',
    _vm.block.has_sibbling ? 'has-sibbling' : '',
  ]},[_c('div',{staticClass:"cta-content__text"},[(_vm.hasAccroche)?_c('p',{staticClass:"mb-0-6 text-medium w-600 mb-0-6",class:[
        `text-md-${_vm.block.text_position}`,
        `text-color-${_vm.block.text_color}`,
      ]},[_vm._v("\n      "+_vm._s(_vm.block.accroche)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasTitle)?_c('p',{staticClass:"cta-content__title w-900",class:[
        _vm.block.is_full ? 'h1' : 'h3',
        _vm.hasCountdownDate || !_vm.hasBtn ? 'mb-0-2' : 'mb-1',
        _vm.hasCountdownDate ? 'text-center' : '',
        `text-md-${_vm.block.text_position}`,
        `text-color-${_vm.block.text_color}`,
      ]},[_vm._v("\n      "+_vm._s(_vm.block.title)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasBtn)?_c('div',{staticClass:"cta-content__btn",class:[
        _vm.block.is_full
          ? 'justify-center'
          : _vm.block.text_position === 'right'
          ? 'justify-end'
          : '',

        _vm.block.text_position === 'left' ? 'justify-md-start' : '',
        _vm.block.text_position === 'center' ? 'justify-md-center' : '',
        _vm.block.text_position === 'right' ? 'justify-md-end' : '',
        _vm.hasCountdownDate ? 'mt-1 mb-0-6 d-none d-md-flex' : 'd-flex',
      ]},[_c('div',[_c('primary-button',{ref:"link",attrs:{"type":"button","text":_vm.block.btn_label,"with-arrow":"","aspect":_vm.block.text_color === 'yellow'
              ? 'yellow'
              : _vm.block.is_full
              ? 'dark'
              : 'light',"loading":_vm.loadingButton}})],1)]):_vm._e()]),_vm._v(" "),(_vm.hasCountdownDate)?_c('div',{staticClass:"cta-content__countdown d-flex d-md-block flex-direction-column align-center mt-1 mt-md-0",class:[`text-color-${_vm.block.text_color}`]},[_c('div',{staticClass:"d-flex justify-center justify-md-end flex-grow-1 mb-0-6"},[_c('div',{staticClass:"tag tag--sun-and-white"},[_c('icon',{attrs:{"name":"estimated-time"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('product.tag.last_before_end')))])],1)]),_vm._v(" "),_c('big-count-down',{attrs:{"date":_vm.countdownDate,"home":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }